var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDepositIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/moneys"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.0833 6.59632V10.888C16.0833 13.4547 14.6167 14.5546 12.4167 14.5546H5.09165C4.71665 14.5546 4.35832 14.5214 4.02498 14.4464C3.81665 14.413 3.61666 14.3547 3.43332 14.288C2.18332 13.8214 1.42499 12.738 1.42499 10.888V6.59632C1.42499 4.02966 2.89165 2.92969 5.09165 2.92969H12.4167C14.2833 2.92969 15.625 3.72135 15.9833 5.52968C16.0417 5.86302 16.0833 6.20466 16.0833 6.59632Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.5842 9.09789V13.3896C18.5842 15.9562 17.1176 17.0562 14.9176 17.0562H7.59257C6.97591 17.0562 6.41758 16.9729 5.93425 16.7896C4.94258 16.4229 4.26758 15.6646 4.02591 14.4479C4.35924 14.5229 4.71758 14.5562 5.09258 14.5562H12.4176C14.6176 14.5562 16.0842 13.4562 16.0842 10.8896V6.59789C16.0842 6.20622 16.0509 5.85625 15.9842 5.53125C17.5676 5.86458 18.5842 6.98122 18.5842 9.09789Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.74869 10.9469C9.96371 10.9469 10.9487 9.96191 10.9487 8.74689C10.9487 7.53186 9.96371 6.54688 8.74869 6.54688C7.53366 6.54688 6.54868 7.53186 6.54868 8.74689C6.54868 9.96191 7.53366 10.9469 8.74869 10.9469Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M3.98334 6.91406V10.5807",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M13.5181 6.91406V10.5807",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepositIcon);
export default __webpack_public_path__ + "static/media/deposit-icon.7666341b853f5d398847e60d745ded9a.svg";
export { ForwardRef as ReactComponent };